(function() {
  'use strict';

  var stickyBlock = document.querySelector('.sticky-add-cart-block');
  var html = document.documentElement;

  // Si el usuario ya cerró la sticky bar, eliminarla
  if (sessionStorage.getItem('sticky')) {
    if (stickyBlock) stickyBlock.remove();
  } else if (stickyBlock) {
    stickyBlock.style.display = 'block';

    // Cerrar sticky bar
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.hide-sticky-bar')) return;
      sessionStorage.setItem('sticky', true);
      stickyBlock.remove();
      html.classList.remove('has-sticky-bar');
    });

    // Mostrar/ocultar según visibilidad del CTA
    function checkButtonVisibility() {
      var btn = document.getElementById('cta-btn-pf');
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      var isHidden = r.bottom > window.innerHeight || r.right > window.innerWidth || r.top < 0 || r.left < 0;
      stickyBlock.classList.toggle('shown', isHidden);
      html.classList.toggle('has-sticky-bar', isHidden);
    }

    document.addEventListener('DOMContentLoaded', function() {
      checkButtonVisibility();
      window.addEventListener('scroll', checkButtonVisibility, { passive: true });
    });

    // Sticky CTA → trigger main CTA
    var stickyBtn = document.querySelector('.sticky_bar_add_cart');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var cta = document.getElementById('cta-btn-pf');
        if (cta) cta.click();
      });
    }

    // Abrir formulario móvil
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.mobile-sticky-bar-box-open')) return;
      toggleMobileForm(true);
    });

    // Cerrar formulario móvil
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.sticky-mobile-layer') && !e.target.closest('.close_sticky_right_form')) return;
      toggleMobileForm(false);
    });

    function toggleMobileForm(open) {
      var form = document.querySelector('.sticky-right-form');
      var layer = document.querySelector('.sticky-mobile-layer');
      var product = document.querySelector('.Product');
      if (form) form.classList.toggle('active', open);
      if (layer) layer.style.display = open ? 'block' : 'none';
      html.classList.toggle('p-no-scroll', open);
      if (product) product.classList.toggle('Over', open);
    }
  }

  // Sincronizar swatches entre principal y sticky
  function syncSwatches(sourceSelector, targetSelector) {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest(sourceSelector + ' .SwatchButton');
      if (!btn) return;
      var parent = btn.closest('.SwatchItem');
      if (!parent) return;
      var targ = parent.getAttribute('data-swatch-target');
      document.querySelectorAll(targetSelector + ' .SwatchButton').forEach(function(b) {
        b.classList.remove('block-selected');
      });
      var match = document.querySelector(targetSelector + ' .SwatchItem[data-swatch-target="' + targ + '"] .SwatchButton');
      if (match) match.classList.add('block-selected');
      var img = parent.querySelector('img');
      var stickyImg = document.querySelector('.sticky_product_image');
      if (img && stickyImg) stickyImg.src = img.getAttribute('src') || img.getAttribute('data-src');
    });
  }
  syncSwatches('.sticky-block-right', '.ProductForm__Swatches');
  syncSwatches('.ProductForm__Swatches', '.sticky-block-right');

  // Contador de visitas (Web Component)
  if (!customElements.get('visit-count')) {
    class VisitCount extends HTMLElement {
      constructor() {
        super();
        this.pid = this.dataset.id;
        this.cookieValue = this._checkCookie();
        if (this.cookieValue) this._updateValue();
      }

      _checkCookie() {
        var count = this._getCookie('visitCount');
        if (count) {
          return count.includes(this.pid) ? '' : count + this.pid + ';';
        }
        return this.pid + ';';
      }

      _updateValue() {
        var self = this;
        fetch('https://dev.vivaconversion.com/satorisan/visit-count-es.php?pid=' + this.pid)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (data.code == 1) self._setCookie('visitCount', self.cookieValue, 7);
          })
          .catch(function() {});
      }

      _setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + days * 864e5);
        document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/';
      }

      _getCookie(name) {
        var eq = name + '=';
        var parts = document.cookie.split(';');
        for (var i = 0; i < parts.length; i++) {
          var c = parts[i].trim();
          if (c.indexOf(eq) === 0) return decodeURIComponent(c.substring(eq.length));
        }
        return null;
      }
    }
    customElements.define('visit-count', VisitCount);
  }
})();